import React from "react";
interface EmbedNowPlayingProps {
  nowPlaying: {
    artist?: string;
    track?: string;
    album?: string;
  } | null;
  isConnected: boolean;
  theme: "light" | "dark";
}

export function EmbedNowPlaying({ nowPlaying, isConnected, theme }: EmbedNowPlayingProps) {
  const mutedTextColor = theme === "dark" ? "text-[#4fa935]" : "text-gray-600";

  if (!isConnected) {
    return (
      <div className="text-center space-y-2">
        <div className={`text-sm ${mutedTextColor}`}>
          CONNECTING...
        </div>
      </div>
    );
  }

  if (!nowPlaying?.track) {
    return (
      <div className="text-center space-y-2">
        <div className={`text-sm ${mutedTextColor}`}>
          NO TRACK INFO
        </div>
      </div>
    );
  }

  return (
    <div className="text-center space-y-1">
      <div className="text-base font-bold truncate">
        {nowPlaying.track}
      </div>
      <div className={`text-sm truncate ${mutedTextColor}`}>
        {nowPlaying.artist} {nowPlaying.album && `– ${nowPlaying.album}`}
      </div>
    </div>
  );
}
